import React, { useEffect, useState, useCallback } from "react";
import Box from "@mui/material/Box";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import TreeView from "@mui/lab/TreeView";
import TreeItem from "@mui/lab/TreeItem";
import LockIcon from "@mui/icons-material/Lock";
import Tooltip from "@mui/material/Tooltip";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

export function ArticleLeftBar({ reloadArticle, setReload, selectArticle }) {
  const [expanded, setExpanded] = useState([]);
  const [selected, setSelected] = useState([]);
  const [articleInEdition, setArticleInEdition] = useState([]);
  const [publishedArticle, setPublishedArticle] = useState([]);
  const [publishArticle, setPublishArticle] = useState([]);
  const [articlesAlreadyPublished, setArticlesAlreadyPublished] = useState([]);
  const [selectedYear, setSelectedYear] = useState(null);
  const { t, i18n } = useTranslation(["Articles"]);
  const userState = useSelector((state) => state.user);

  const currentYear = new Date().getFullYear();
  const yearList = [
    currentYear - 3,
    currentYear - 2,
    currentYear - 1,
    currentYear,
  ];

  const fetchArticles = useCallback(
    async (endpoint, setState) => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/article/${endpoint}`,
          {
            method: "GET",
            withCredentials: true,
            credentials: "include",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${userState.token}`,
            },
          }
        );
        const data = await response.json();
        setState(data);
      } catch (error) {
        console.error(`Failed to fetch ${endpoint}`, error);
      }
    },
    [userState.token]
  );

  const fetchArticlesAlreadyPublishedByYear = useCallback(
    async (year) => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/article/GetArticlesAlreadyPublishedByYear/${year}`,
          {
            method: "GET",
            withCredentials: true,
            credentials: "include",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${userState.token}`,
            },
          }
        );
        const data = await response.json();
        setArticlesAlreadyPublished(data);
      } catch (error) {
        console.error(`Failed to fetch articles already published`, error);
      }
    },
    [userState.token]
  );

  useEffect(() => {
    fetchArticles("GetPublishedArticles", setPublishArticle);
    fetchArticles("GetArticlesInEdition", setArticleInEdition);
    fetchArticlesAlreadyPublishedByYear(selectedYear);
    setReload(false);
  }, [reloadArticle, fetchArticles, setReload]);

  const handleToggle = (event, nodeIds) => {
    setExpanded(nodeIds);
  };

  const handleSelect = (event, nodeIds) => {
    console.log("Handle select called with:", nodeIds);
    setSelected(nodeIds);
    handleYearSelect(nodeIds);
  };

  const handleYearSelect = (nodeId) => {
    console.log("NodeId received:", nodeId);

    // Handle array of nodeIds
    const id = Array.isArray(nodeId) ? nodeId[0] : nodeId;

    if (typeof id === "string" && id.startsWith("year-")) {
      const year = parseInt(id.replace("year-", ""));
      console.log("Year parsed:", year);

      if (!isNaN(year) && yearList.includes(year)) {
        // Only proceed if year is valid and in our list
        console.log("Setting year:", year);
        setSelectedYear(year);
        fetchArticlesAlreadyPublishedByYear(year);
      }
    }
  };

  // Add useEffect to monitor state changes
  useEffect(() => {
    console.log("Selected year changed to:", selectedYear);
  }, [selectedYear]);

  const renderArticleLabel = (article) => {
    const lang = i18n.language;
    const title = lang === "FR" ? article.titleFr : article.titleEn;
    return article.idEmployeLock ? (
      <Tooltip title={`Lock by ${article.employeLock}`} placement="right" arrow>
        <span>
          {title} <LockIcon />
        </span>
      </Tooltip>
    ) : (
      <span>{title}</span>
    );
  };

  const renderTreeItems = (articles, label, nodeId) => {
    // Ensure articles is an array
    const articlesArray = Array.isArray(articles) ? articles : [];

    return (
      <TreeItem nodeId={nodeId} label={label}>
        {articlesArray.map((article) => (
          <TreeItem
            key={article.id}
            nodeId={article.id.toString()}
            label={renderArticleLabel(article)}
            onClick={() => selectArticle(article)}
          />
        ))}
      </TreeItem>
    );
  };

  const renderTreeItemByYear = (year) => {
    return (
      <TreeItem nodeId={year.toString()} label={year}>
        {publishedArticle
          .filter(
            (a) =>
              new Date(a.publishedDate).getFullYear() >= year &&
              new Date(a.endPublishedDate).getFullYear() < year + 1
          )
          .map((article) => (
            <TreeItem
              key={article.id}
              nodeId={article.id.toString()}
              label={renderArticleLabel(article)}
              onClick={() => selectArticle(article)}
            />
          ))}
      </TreeItem>
    );
  };

  console.log(selectedYear);
  return (
    <div className="EdditionInProgress__Main">
      <div className="EdditionInProgress__Title">
        <h3>{t("Articles")}</h3>
      </div>
      <div className="EdditionInProgress__Treeview">
        <Box
          sx={{ height: 270, flexGrow: 1, maxWidth: 400, overflowY: "auto" }}
        >
          <TreeView
            aria-label="controlled"
            defaultCollapseIcon={<ExpandMoreIcon />}
            defaultExpandIcon={<ChevronRightIcon />}
            expanded={expanded}
            selected={selected}
            onNodeToggle={handleToggle}
            onNodeSelect={(event, nodeId) => {
              handleSelect(event, nodeId);
            }}
            multiSelect
          >
            {renderTreeItems(articleInEdition, t("InEddition"), "24500")}
            {renderTreeItems(publishArticle, t("Published"), "26000")}
            <TreeItem nodeId="40000" label={t("AlreadyPublished")}>
              {yearList.map((year) => (
                <TreeItem key={year} nodeId={`year-${year}`} label={year}>
                  {selectedYear === year
                    ? renderTreeItems(
                        articlesAlreadyPublished,
                        t("AlreadyPublished"),
                        `published-${year}`
                      )
                    : null}
                </TreeItem>
              ))}
            </TreeItem>
          </TreeView>
        </Box>
      </div>
    </div>
  );
}

export default ArticleLeftBar;
